export const Steps = [
  "testVideo",
  "testMicrophone",
  "testAudio",
  "completed",
] as const;
export type Step = (typeof Steps)[number];
